export default __webpack_public_path__ + "static/media/checkmark_mixed.3a4c98d7.svg";